var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointsOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F6B119",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.954 20.009-2.981-5.963a8.953 8.953 0 0 0 1.546-5.04C19.52 4.04 15.48 0 10.514 0 5.55 0 1.51 4.04 1.51 9.005c0 1.866.571 3.602 1.547 5.041L.074 20.01a.705.705 0 0 0 .63 1.02h3.421l2.053 2.736a.705.705 0 0 0 1.193-.108l2.827-5.653a9.039 9.039 0 0 0 .632 0l2.827 5.653a.705.705 0 0 0 1.194.108l2.052-2.736h3.421a.704.704 0 0 0 .63-1.02zM6.621 22.008 5.041 19.9a.704.704 0 0 0-.564-.281H1.844l2.187-4.372a9.001 9.001 0 0 0 4.68 2.58l-2.09 4.18zM2.918 9.005c0-4.188 3.408-7.596 7.596-7.596 4.189 0 7.596 3.408 7.596 7.596 0 4.189-3.407 7.596-7.596 7.596-4.188 0-7.596-3.407-7.596-7.596zM16.551 19.62a.705.705 0 0 0-.564.281l-1.58 2.107-2.089-4.18a9.001 9.001 0 0 0 4.68-2.58l2.186 4.371h-2.633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.11 10.174 1.968-2.349a.704.704 0 0 0-.369-1.136l-2.972-.743-1.625-2.597a.704.704 0 0 0-1.195 0L8.292 5.946 5.32 6.69a.705.705 0 0 0-.369 1.136l1.967 2.349-.211 3.056a.705.705 0 0 0 .966.702l2.841-1.145 2.842 1.145a.705.705 0 0 0 .966-.702l-.211-3.056zm-1.262-.688a.704.704 0 0 0-.163.501l.154 2.217-2.061-.83a.704.704 0 0 0-.527 0l-2.06.83.153-2.216a.705.705 0 0 0-.163-.502L6.754 7.783l2.155-.539a.704.704 0 0 0 .427-.31l1.179-1.883 1.179 1.883c.096.155.249.266.426.31l2.155.54-1.427 1.702z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsOrange);
export default __webpack_public_path__ + "static/media/points-orange.eeccc9e0c42bc4a41bf16f3f08846b12.svg";
export { ForwardRef as ReactComponent };